import React from 'react'

const packageDetail = ({ companiesDetails }) => {
    return (
        <div className='pagiTable packageTable'>
            <h2>Package Details</h2>
            {companiesDetails?.package?.length ? (
                companiesDetails.package.map((pkg, index) => (
                    <div key={index}>
                        <ul>
                            <li>Title: <span>{pkg.title || 'N/A'}</span></li>
                            <li>Description: <span>{pkg.description || 'N/A'}</span></li>
                            <li>Price: <span>{pkg.price ?? 'N/A'}</span></li>
                            <li>SKU: <span>{pkg.sku || 'N/A'}</span></li>
                            <li>Users: <span>{pkg.userCount ?? 0}</span></li>
                            <li>Brands: <span>{pkg.brandCount ?? 0}</span></li>
                            <li>Duration: <span>{pkg.duration ? `${pkg.duration} days` : 'N/A'}</span></li>
                        </ul>
                    </div>
                ))
            ) : (
                <p style={{ marginLeft: '5px' }}>No package assigned</p>
            )}
        </div>
    )
}
export default packageDetail;
